import Box from "@mui/material/Box";

import { TINY, marketingPalette } from "./tokens";

/**
 * `.ppc-nav_wrap`: the bar two paid-search pages open on instead of the
 * site's navigation, the wordmark alone, centred, and not a link, over a
 * hairline.
 */
export default function WordmarkBar() {
  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: "16px",
        borderBottom: `1px solid ${marketingPalette.outline}`,
        [TINY]: { py: "8px" },
      }}
    >
      <Box
        component="img"
        src="/marketing/nav/webshare-wordmark.svg"
        alt="Webshare"
        sx={{ display: "block", width: "209px", height: "34px" }}
      />
    </Box>
  );
}
